export const capitalize = (word) =>
  word.toLowerCase().charAt(0).toUpperCase() + word.toLowerCase().slice(1);
